"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPrefsStore = exports.QuerySearchTypes = exports.QuerySortTypeValues = exports.QuerySortTypes = void 0;
var config_1 = __importDefault(require("config"));
var Store_1 = require("./Store");
var mobx_1 = require("mobx");
var QuerySortTypes;
(function (QuerySortTypes) {
    QuerySortTypes["DEFAULT"] = "Default Sort Order";
})(QuerySortTypes = exports.QuerySortTypes || (exports.QuerySortTypes = {}));
var QuerySortTypeValues;
(function (QuerySortTypeValues) {
    QuerySortTypeValues["DEFAULT"] = "name";
})(QuerySortTypeValues = exports.QuerySortTypeValues || (exports.QuerySortTypeValues = {}));
var QuerySearchTypes;
(function (QuerySearchTypes) {
    QuerySearchTypes["ACCOUNT_NUMBER"] = "acNumber";
    QuerySearchTypes["CUSTOMER"] = "customer";
})(QuerySearchTypes = exports.QuerySearchTypes || (exports.QuerySearchTypes = {}));
var storage_keys = config_1.default.storage_keys;
var CustomerPrefsStore = /** @class */ (function (_super) {
    __extends(CustomerPrefsStore, _super);
    function CustomerPrefsStore(data) {
        var _this = _super.call(this, data) || this;
        _this.setData = function (data) {
            if (localStorage.getItem(storage_keys.CUSTOMER_PREFS) == null)
                localStorage.setItem(storage_keys.CUSTOMER_PREFS, JSON.stringify(data));
            _this.data = data;
        };
        _this.unsetData = function () {
            localStorage.removeItem(storage_keys.CUSTOMER_PREFS);
            _this.data = null;
        };
        _this.editData = function (data) {
            _this.data = __assign(__assign({}, _this.data), data);
            localStorage.setItem(storage_keys.CUSTOMER_PREFS, JSON.stringify(mobx_1.toJS(_this.data)));
        };
        return _this;
    }
    return CustomerPrefsStore;
}(Store_1.Store));
exports.CustomerPrefsStore = CustomerPrefsStore;
var prefData = localStorage.getItem(storage_keys.CUSTOMER_PREFS);
var initialTable = {
    perPage: 100,
    page: 1,
    results: 0,
    totalPages: 1,
    search: '',
    sort: 'name'
};
var initData = {
    queryPrefs: {
        searchValue: "",
        currentQueryType: "All Query Types",
        sortType: QuerySortTypes.DEFAULT,
        sortTypeValue: QuerySortTypeValues.DEFAULT,
        currentCountry: "UK"
    },
    queryTable: initialTable
};
var customerPrefsStore = new CustomerPrefsStore(prefData !== null && JSON.parse(prefData) || initData);
exports.default = customerPrefsStore;
